import { render } from "./InitiativeEditor.vue?vue&type=template&id=5d2b1504"
import script from "./InitiativeEditor.vue?vue&type=script&lang=js"
export * from "./InitiativeEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/InitiativeEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d2b1504"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d2b1504', __exports__)) {
    api.reload('5d2b1504', __exports__)
  }
  
  module.hot.accept("./InitiativeEditor.vue?vue&type=template&id=5d2b1504", () => {
    api.rerender('5d2b1504', render)
  })

}


export default __exports__